import Alert from '@mui/material/Alert'
import AlertTitle from '@mui/material/AlertTitle'
import Box from '@mui/material/Box'
import Spacings from '../../../figma/tokens/Spacings'
import { ExternalCustomerSection } from './ExternalCustomerSection'
import { GroupingConfigSection } from './GroupingConfigSection'

type CustomerTravelTabProps = {
  customerId: string
}

export const CustomerTravelTab = ({ customerId }: CustomerTravelTabProps) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: Spacings.medium, width: '100%' }}>
    <Alert severity="info">
      <AlertTitle>Beta feature</AlertTitle>
      Travel card/account is under development - consult tech-card-n-ledger for questions
    </Alert>
    <Box
      data-testid="travel-columns"
      sx={{ display: 'flex', flexDirection: 'row', gap: Spacings.medium, alignItems: 'flex-start', width: '100%' }}
    >
      <Box sx={{ width: 480, flexShrink: 0 }}>
        <ExternalCustomerSection customerId={customerId} />
      </Box>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <GroupingConfigSection customerId={customerId} />
      </Box>
    </Box>
  </Box>
)
